export default __webpack_public_path__ + "static/media/elevate-wht-1.ea8e8380.png";